const UtilityCard = ({ id, title, desc }) => {
  return (
    <div class="col-md-4">
      <div class={`utility-card utility-card-${id}`}>
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
    </div>
  );
};

export default UtilityCard;
